import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { ILineGraphBehavior } from "../../../../documaker/domain/format/objects";

export interface ILineGraphBehaviorPropertyEditable {
  lineGraphBehavior(): IPropertyEditable<ILineGraphBehavior>;
  getLineGraphValueTypes(): string[];
}

export function instanceOfILineGraphBehaviorPropertyEditable(instance: any): instance is ILineGraphBehaviorPropertyEditable {
  return instance
      && instance.lineGraphBehavior
      && instance.getLineGraphValueTypes
      && instanceOfIPropertyEditable<ILineGraphBehavior>(instance.lineGraphBehavior());
}
